// removed by extract-text-webpack-plugin
module.exports = {"tabs1-wrapper":"tabs1-wrapper","nf-contractcenter-grid":"nf-contractcenter-grid","message-center-table-header":"message-center-table-header"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/ContractCenter/ContractCenter.scss
// module id = 5448
// module chunks = 1